<template>
  <div class="imageUploadComponent">
    <label
      v-bind:for="uniqueId"
      v-on:dragover="dragover"
      v-on:dragleave="dragleave"
      v-on:drop="drop"
      v-bind:style="dragZoneStyle"
      class="imageUploadComponent_img_wrap"
    >

      <span v-if="!computedImage" class="fs_15">{{ type != 'image' ? 'ファイル' : '画像' }}</span>
      <span v-if="imageUrl && type != 'image'">{{ fileName }}</span>
      <img v-if="computedImage && type == 'image'" class="imageUploadComponent_img" v-bind:src="computedImage" alt="">
    </label>

    <slot name="image-bottom"></slot>

    <div class="imageUploadComponent_btns">
      <label v-bind:class="{'disabled':disabled}" class="imageUploadComponent_btns_btn imageUploadComponent_btns_btn__green" v-bind:for="uniqueId">
        添付
      </label>
      <button type="button" v-bind:class="{'disabled':disabled}" v-bind:disabled="disabled" class="imageUploadComponent_btns_btn imageUploadComponent_btns_btn__red" v-on:click="deleteMedia()">
        削除
      </button>

      <input v-bind:id="uniqueId" class="imageUploadComponent_btns_btn_file" type="file" v-on:change="changeImage" ref="inputFile" v-if="!disabled">
      <input type="hidden" v-bind:name="inputName" v-bind:value="computedImage">
    </div>
  </div>
</template>


<script>
export default {
  props:['image', 'inputName', 'initType', 'initTitle', 'initDisabled', 'initStoreDir'],
  data(){
    return{
      uniqueId:"",
      previewImage:this.image,
      imageUrl:this.image,
      dragZoneStyle:{},
      type:this.initType ?? 'image',
      storeDir:this.initStoreDir ?? 'temp',
      disabled:this.initDisabled
    }
  },
  methods:{
    dragover(e){
      e.stopPropagation();
      e.preventDefault();

      this.dragZoneStyle.background = "#ff3399";
    },
    dragleave(e){
      e.stopPropagation();
      e.preventDefault();

      this.dragZoneStyle.background = "#ffffff";
    },
    drop(e){
      e.stopPropagation();
      e.preventDefault();

      this.dragZoneStyle.background = "#ffffff";

      this.changeImage(e);
    },
    changeImage(event){
      if ((event.target.files || event.dataTransfer.files).length == 0) {
        return;
      }

      const file = (event.target.files || event.dataTransfer.files)[0];
      let beforeImage = this.computedImage;

      /*------------------------- 容量チェック -------------------------*/
      if (file.size >= 50000000) {
        alert('一度に選択できるファイル容量を超えています。\n ' + '50MB以下になるように選択してください。\n ');
        return;
      }

      /*------------------------- 拡張子チェック -------------------------*/
      if (this.type == 'image') {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg') {
          alert('対応外の形式です。jpeg、png形式の画像のみアップロード可能です。');
          return;
        }
      }

      this.previewImage          = window.URL.createObjectURL(file);
      this.$refs.inputFile.type  = 'text';
      this.$refs.inputFile.value = null;
      this.$refs.inputFile.type  = 'file';

      // 画像送信
      let formData = new FormData();
      formData.append('file', file);

      if (this.type != 'image') {
        let fileName = file.name;
        formData.append('file_name', fileName);
      }

      // ディレクトリ
      formData.append('store_dir', this.storeDir);

      let config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      };

      this.isUploading = true;
      axios
        .post("/api/media-upload", formData, config)
        .then((response) => {
          if(response.data.success == false){
            // 途中でエラーが出た場合は、前の画像に戻す
            alert("アップロード中にエラーが発生しました。時間を置いてもう一度お試しください。")
            this.previewImage  = null;
            this.computedImage = beforeImage;
            return;
          }

          this.previewImage  = null;
          this.computedImage = response.data['path'];
        })
        .catch((error) => {
          // 途中でエラーが出た場合は、前の画像に戻す
          alert("アップロード中にエラーが発生しました。時間を置いてもう一度お試しください。")
            this.previewImage  = null;
            this.computedImage = response.data['path'];
        })
        .finally(() => {
          this.isUploading = false;
        });
    },
    deleteMedia(){
      this.$set(this, 'computedImage', null);
    }
  },
  computed:{
    fileName(){
      return
    }
  },
  created() {
    this.uniqueId = "imageUpload_"+Math.random().toString(32).substring(2) // 'a6dpgjqlq8g' 等
  },
  watch:{
    image(){
      this.previewImage = this.image;
    }
  },
  computed:{
    fileName(){
      return this.imageUrl.substring(this.imageUrl.lastIndexOf('/') + 1);
    },
    computedImage:{
      get(){
        return this.previewImage;
      },
      set(image){
        this.imageUrl     = image;
        this.previewImage = image;
        this.$emit('input', image);
      }
    }
  }
}
</script>
<style lang="scss">
$col_red: #eb4141;
$col_green: #2e9141;

.imageUploadComponent{
  display: grid;
  grid-template-rows: 1fr auto;
  height: 100%;
  aspect-ratio: 1/1;
  &_img{
    height: 100%;
    width: 100%;
    position: absolute;
    &_wrap{
      position: relative;
      display: grid;
      place-items: center;
      width: auto;
      max-width: 100%;
      height: 100%;
      background: #ffffff;
      border: 1px solid #000000;
      border-radius: 4px;
    }
  }
  &_btns{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin-top: 10px;
    &_btn{
      border-radius: 4px;
      padding: 5px 10px;
      display: grid;
      place-items: center;
      border: 1px solid #000000;
      color: #ffffff;
      font-weight: bold;
      cursor: pointer;

      &.disabled{
        background: #666666;
        pointer-events: none;
      }

      &__green{
        background-color: $col_green;
      }

      &__red{
        background-color: $col_red;
      }
      &_file{
        display: none;
      }
    }
  }
}
</style>
